export default function Offering() {
  return (
    <div className="max-w-3xl mx-auto p-6 bg-white">
      <h1 className="text-2xl font-serif mb-6 text-gray-800 border-b pb-2">
        Offering Information
      </h1>

      {/* Main content */}
      <div className="space-y-4 mb-8 text-gray-700">
        <p>
          The monastery operates as a non-profit and is therefore sustained
          through offerings. You may offer food, accommodation, and support to
          the monastery.
        </p>

        <p>
          Contributions can be made directly at the registration office or via
          bank transfer. The International Meditation Center – Thai Plum Village
          is a center for practicing mindful living, following the teachings of
          the Buddha. The monastery is a non-profit organization run through
          offerings and financial support from retreat participants and friends
          who wish to maintain a mindful way of living. The monastery is deeply
          grateful for each donation, which is seen as a heartfelt gift.
        </p>

        <p>
          Offering (Dana) is one of the fundamental practices that brings us a
          lot of joy and happiness in everyday life. It is not only about
          material support but also involves sharing time, energy, experience,
          and insight from the practice.
        </p>

        <p>
          For meditation practitioners coming to practice at the monastery, the
          monks and nuns kindly suggest contributing to cover costs for food and
          accommodation. You can contribute directly to the offering box (phước
          sương) placed in the meditation hall or via bank transfer before
          arriving at the monastery.
        </p>

        <p>
          If you wish to further extend your generosity, the monastery expresses
          deep gratitude for your offering through the bank account of the Thai
          Plum Village Foundation. Your contributions will be used to support
          the daily needs of the monks and nuns, provide financial aid to
          low-income retreatants, and cover building, maintenance, and other
          related expenses for the Sangha community.
        </p>
      </div>

      {/* Promotional Image */}
      <div className="mb-8">
        <img
          src="https://static.wixstatic.com/media/b4e2e4_9deb01b31ebd498c87f6820b0cf35383~mv2.jpg/v1/fill/w_530,h_750,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/viber_image_2024-09-23_15-34-43-619.jpg"
          alt="Offering to the Triple Gem"
          className="mx-auto rounded-lg shadow-md"
        />
      </div>

      {/* Bank Account Information */}
      <div className="space-y-8">
        <div className="bg-gray-50 p-6 rounded-lg">
          <h2 className="font-medium text-lg mb-4">Bank Account Information</h2>

          <div className="space-y-6">
            {/* First Bank Account */}
            <div>
              <h3 className="font-medium text-gray-800">
                Bank Account in Vietnam:
              </h3>
              <ul className="mt-2 space-y-2">
                <li>
                  Account Name: Nguyễn Ba Minh (Venerable Chan Troi Nguyen Uc)
                </li>
                <li>Account Number: 1724668148</li>
                <li>Asia Commercial Bank (ACB), Ho Chi Minh City Branch</li>
                <li>
                  Swift Code: <span className="font-mono">ASCBVNVX</span> -
                  Zalo: <span className="font-mono">0947221708</span>
                </li>
                <li>Or transfer via the QR code below</li>
              </ul>
            </div>

            {/* Second Bank Account */}
            <div>
              <h3 className="font-medium text-gray-800">
                Bank Account in Thailand:
              </h3>
              <ul className="mt-2 space-y-2">
                <li>Account Name: PV Foundation for Monastic</li>
                <li>Account Number: 593446556</li>
                <li>Bangkok Bank - Hat Chong Branch - Thailand</li>
                <li>
                  SWIFT Code: <span className="font-mono">BKKBTHBK</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className="text-center text-gray-600 text-sm">
          For inquiries, please contact:{" "}
          <a
            href="mailto:support@sangha@thaiplumvillage.org"
            className="text-blue-600 hover:underline"
          >
            support@sangha@thaiplumvillage.org
          </a>
        </div>
      </div>
    </div>
  );
}
